import { GoodsType } from '../../types/api/order-request'

export const orderRequestType: GoodsType[] = ['Материалы', 'Штампы']
